/**
 * Som sutil de "nova mensagem" do chat da Beaa.
 * Sintetizado com a Web Audio API (sem arquivo de áudio), um blip curto e macio.
 * O navegador só libera áudio após uma interação do usuário, por isso
 * unlockBeaaAudio() deve ser chamado a partir de um clique.
 */

type AudioContextCtor = typeof AudioContext;

let audioCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const ctor: AudioContextCtor | undefined =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: AudioContextCtor }).webkitAudioContext;
  if (!ctor) return null;
  if (!audioCtx) {
    audioCtx = new ctor();
  }
  return audioCtx;
}

/** Libera/retoma o contexto de áudio a partir de uma interação do usuário. */
export function unlockBeaaAudio() {
  const ctx = getContext();
  if (ctx && ctx.state === 'suspended') {
    ctx.resume().catch(() => {
      /* aguarda uma futura interação do usuário */
    });
  }
}

/** Toca um blip curto e discreto anunciando uma nova mensagem da Beaa. */
export function playBeaaMessageSound() {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {
      /* áudio ainda bloqueado; ignora silenciosamente */
    });
  }

  const now = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = 'sine';
  osc.frequency.setValueAtTime(740, now);
  osc.frequency.exponentialRampToValueAtTime(1180, now + 0.09);

  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.05, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.24);

  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.26);
}